module.exports = __webpack_public_path__ + "img/Weapon_263.463ae9f7.png";